<div class="global-filter">
    <div class="global-filter__head">
        <!-- <div class="global-filter__head-text">
            <p class="global-filter__title">Global filter conditions</p>
            <p class="global-filter__description">
                These conditions apply to every filter below and can be used to narrow the dataset before any page or tab filters are applied.
            </p>
        </div> -->
        <button type="button" class="global-filter__add-btn" (click)="addCondition()">
            <mat-icon aria-hidden="true">add</mat-icon>
            <span>Add condition</span>
        </button>
    </div>

    <div class="global-filter__chips" *ngIf="conditions.length">
        <span class="global-filter__chip" *ngFor="let condition of conditions"
            [class.global-filter__chip--active]="condition.id === activeConditionId">
             <button type="button" [attr.aria-pressed]="condition.id === activeConditionId" (click)="selectCondition(condition)">
                 {{ getColumnLabel(condition) }}
             </button>
            <button type="button" class="global-filter__chip-remove" aria-label="Remove condition"
                (click)="removeCondition(condition); $event.stopPropagation()">
                <mat-icon aria-hidden="true">close</mat-icon>
            </button>
        </span>
    </div>

    <div class="global-filter__panel" *ngIf="activeCondition as condition">
        <div class="global-filter__panel-head">
            <span class="global-filter__panel-title">Condition: {{ getColumnLabel(condition) }}</span>
            <span class="global-filter__panel-count">{{ condition.selectedValues.length }} selected values</span>
        </div>

        <div class="global-filter__field">
            <label class="global-filter__field-label">Column</label>
            <mat-select class="global-filter__select" placeholder="Select column" [ngModel]="condition.columnKey"
                (ngModelChange)="onColumnSelected(condition, $event)">
                <mat-option *ngFor="let option of condition.availableColumns" [value]="option.key">{{ option.label }}</mat-option>
            </mat-select>
        </div>

        <ng-container *ngIf="condition.columnKey">
            <input type="text" class="global-filter__search" placeholder="Search values..." [(ngModel)]="condition.searchTerm" />

            <div class="global-filter__values">
                <p class="global-filter__value-loading" *ngIf="condition.valuesLoading">Loading values...</p>
                <label class="global-filter__value-item" *ngFor="let value of filteredValues(condition)">
                    <input type="checkbox" [checked]="isValueSelected(condition, value)" (change)="toggleValue(condition, value)" />
                    <span>{{ value }}</span>
                </label>
                <p class="global-filter__value-empty" *ngIf="!condition.valuesLoading && !filteredValues(condition).length">
                    No values found.
                </p>
            </div>

            <div class="global-filter__footer">
         <span class="global-filter__footer-count" *ngIf="activeCondition as condition">
             {{ condition.selectedValues.length }} of {{ condition.availableValues.length }} values selected
         </span>
         <div class="global-filter__footer-actions">
             <button type="button" class="global-filter__btn global-filter__btn--secondary" (click)="onCancel()">Cancel</button>
             <button type="button" class="global-filter__btn global-filter__btn--primary" (click)="onApply()">Apply</button>
         </div>
     </div>
        </ng-container>
    </div>
</div>
